import './SpeedQuizList.scss';
import { ObjectType } from '../../Core/Types/base';
import { SpeedquizEntity } from '../../Core/Types/admin/speedquiz';
import { useGetSpeedquizInstancesForLoggedInUser } from '../../Core/Hooks/useSpeedquiz';
import { getPathWithRootPath, getSiteRootPath } from '../../Core/Services/common';
import { BizIcon } from '../../Core/Components/Mini/BizIcon';
import { useState } from 'react';

interface SpeedQuizListProps {
	objectType?: ObjectType;
	objectId?: number;
	getLegacyQuizComponent?: (quizId: number, customBackFn?: () => void) => React.ReactNode;
}

const SpeedQuizList = ({ objectType, objectId, getLegacyQuizComponent }: SpeedQuizListProps) => {
	// Use hooks for data fetching
	const { data: speedquizes, statusState } = useGetSpeedquizInstancesForLoggedInUser(objectType, objectId);
	const [legacyQuizComponent, setLegacyQuizComponent] = useState<React.ReactNode>(null);

	const playSpeedquiz = (speedquiz: SpeedquizEntity) => {
		if (getLegacyQuizComponent) {
			const legacyComponent = getLegacyQuizComponent(speedquiz.Id, () => setLegacyQuizComponent(null));
			if (legacyComponent) {
				setLegacyQuizComponent(legacyComponent);
				return;
			}
		}

		// This would typically navigate to the speedquiz play page
		// For now, we'll use the existing pattern from the AngularJS implementation
		const url = `${getSiteRootPath()}modules/speedquiz/play/${speedquiz.UrlRewrite}/${speedquiz.PluginInstanceId}`; //TODO FIX LINK, BAD LINK NOW, RELOADS PAGE!!!
		window.location.href = url;
	};

	const goToHighscore = (speedquiz: SpeedquizEntity) => {
		// Navigate to highscore page
		const url = `${getSiteRootPath()}modules/speedquiz/highscore/${speedquiz.Id}`; //TODO FIX LINK, BAD LINK NOW, RELOADS PAGE!!!
		window.location.href = url;
	};

	// const formatDate = (date: Date | undefined): string => {
	// 	if (!date) return '';
	// 	return new Date(date).toLocaleDateString();
	// };

	if (legacyQuizComponent) {
		return <div className='biz-speedquiz-legacy'>{legacyQuizComponent}</div>;
	}

	if (speedquizes.length === 0) {
		return (
			<div className='biz-speedquiz-list'>
				<div className='no-quizzes'>
					{statusState === 'SUCCESS' &&
						(objectType && objectId ? 'No quizzes are linked to this item.' : 'No quizzes available.')}
					{statusState === 'LOADING' && <BizIcon icon='LOADING' />}
				</div>
			</div>
		);
	}

	return (
		<div className='biz-speedquiz-list'>
			<div className='quiz-list'>
				{speedquizes.map((speedquiz) => (
					<div key={speedquiz.Id} className='quiz-item-outer'>
						<div className='quiz-item'>
							{speedquiz.ImageUrl && (
								<div className='quiz-image'>
									<img src={getPathWithRootPath(speedquiz.ImageUrl, 'sm')} alt={speedquiz.Name} />
								</div>
							)}
							<div className='quiz-content'>
								<div className='quiz-name'>
									<h3>{speedquiz.Name}</h3>
									{speedquiz.Description && <span className='quiz-desc'>{speedquiz.Description}</span>}
								</div>
								{/* {speedquiz.StartTime && (
									<div className='quiz-date'>
										<span>{formatDate(speedquiz.StartTime)}</span>
									</div>
								)} */}
								<div className='quiz-content-bottom'>
									<div className='quiz-item-actions'>
										<button className='biz-btn biz-primary' onClick={() => playSpeedquiz(speedquiz)}>
											Play Quiz
										</button>
										<button
											className='biz-btn biz-secondary'
											onClick={() => goToHighscore(speedquiz)}
											style={{ display: 'none' }}
										>
											Highscore
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default SpeedQuizList;
